import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    isSonim: boolean;
    httpHeaders: any = {};
    current_route: string;
    isUTFFlow: boolean = false;

    constructor(
        private location: Location,
        private router: Router) {
        this.isSonim = (/SONIM-XP5800|SONIM-XP3800/i.test(navigator.userAgent));
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
            this.current_route = this.router.url;
            if (this.current_route.indexOf('cfet') !== -1) {
                this.isUTFFlow = false;
            } else {
                this.isUTFFlow = true;
            }
        });
    }
}
